import React, {  useEffect, useContext, useRef } from 'react';
import './MoodSnapshot.css';
import convenienceApi from '../../common/api/convenience';
import Card from '../Card/Card';
import CardContent from '../Card/CardContent';
import CardLink from '../Card/CardLink';
import CardLinkReport from '../Card/CardLinkReport';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import { CheckinContext } from '../../contexts/CheckinContext';
import { CardMoodSnapshotContext } from '../../contexts/CardMoodSnapshotContext';
import MoodSnapshotContent from './MoodSnapshotContent';
import MoodSnapshotLoadingStatus from './MoodSnapshotLoadingStatus';
import logComponent from '../../common/logComponent';

export default function MoodSnapshot({ moduleDescription }) {
  const environmentContext = useContext(EnvironmentContext);
  const checkinContext = useContext(CheckinContext);
  const cardMoodSnapshotContext = useContext(CardMoodSnapshotContext);
  const { hasToken, activeUser: user, selectedMonitoredIndividual, selectedUnit, reportsEnabled } = environmentContext;
  const { moodSnapshot } = cardMoodSnapshotContext;
  const loadingRef = useRef(false);

  if (logComponent('MoodSnapshot')) { console.debug('MoodSnapshot rendered'); }

  const setLoadingRef = (el) => {
    if (logComponent('MoodSnapshot')) { console.debug('MoodSnapshot setLoadingRef'); }
    loadingRef.current = el;
  }

  useEffect(() => {
    if (logComponent('MoodSnapshot')) {console.debug('MoodSnapshot onMount'); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (!hasToken) return;

    loadData();
  }, []);

  useEffect(() => {
    if (logComponent('MoodSnapshot')) {console.debug('MoodSnapshot useEffect [environmentContext.hasToken,environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit, checkinContext.mostRecentCheckinCompletionTime]'); }
    if (!hasToken) return;

    loadData();
  }, [environmentContext.hasToken, environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit, checkinContext.mostRecentCheckinCompletionTime]);

  const loadData = () => {
    if (logComponent('MoodSnapshot')) {console.debug('MoodSnapshot loadData'); }

    if (!hasToken || loadingRef.current) return;
    setLoadingRef(true);
    const { setMoodSnapshot, setMoodSnapshotLoading, setMoodSnapshotError } = cardMoodSnapshotContext;

    setMoodSnapshot(null);
    setMoodSnapshotLoading(true);
    setMoodSnapshotError(false);

    convenienceApi.getMoodSnapshotData(selectedMonitoredIndividual, selectedUnit)
      .then(
        result => {
          setMoodSnapshot(result);
          setMoodSnapshotLoading(false);
          setMoodSnapshotError(false);
          setLoadingRef(false);
       },
        error => {
          setMoodSnapshot(null);
          setMoodSnapshotLoading(false);
          setMoodSnapshotError(true);
          setLoadingRef(false);
        }
      )
  }



  return (
    <Card className="Mood-Snapshot" title="Mood snapshot" moduleDescription={moduleDescription} icon={['far', 'smile']} dataLoaded={!!moodSnapshot}>
      <CardContent>
        <MoodSnapshotContent />
        <MoodSnapshotLoadingStatus reloadAction={loadData} />
      </CardContent>
      {
        user.groupTypeString !== 'Family' && reportsEnabled &&
        <CardLink>
            <CardLinkReport reportId={3} />
        </CardLink>
      }
    </Card>
  );
}